import { log } from '@swiper/core';

export default function createLogHook( opts={} ) {
  return context => {
    const { type, path, method, error, result } = context;
    log.debug( `${type} app.service('${path}').${method}()` );

    // if ( error && ! result ) log.debug( error.message );
    if ( error && ! result ) log.error( error.stack );
    // if ( error && ! result ) log.error( error );
  };
}
